import { Component, computed, inject } from '@angular/core';
import { UserSessionService } from '../../../../core/services/user-session.service';
import { AuthorizationService } from '../../../../core/services/authorization/authorization.service';
import { AuthorizationStateService } from '../../../../core/services/authorization/authorization-state.service';
import { StaffDashboardComponent } from '../../components/staff-dashboard/staff-dashboard.component';
import { OrgDashboardComponent } from '../../components/org-dashboard/org-dashboard.component';
import { DashboardNoActiveOrgPromptComponent } from '../../components/dashboard-no-active-org-prompt/dashboard-no-active-org-prompt.component';
import { DashboardViewMode } from '../../../../core/enums/dashboard.enums';

@Component({
	selector: 'ms-dashboard-page',
	imports: [
		StaffDashboardComponent,
		OrgDashboardComponent,
		DashboardNoActiveOrgPromptComponent
	],
	templateUrl: './dashboard.page.html',
	styleUrl: './dashboard.page.scss'
})
export class DashboardPage {

	private userSessionService = inject(UserSessionService);
	private authorizationService = inject(AuthorizationService);
	private authorizationStateService = inject(AuthorizationStateService);

	//#region Constants

	public DashboardViewMode = DashboardViewMode;

	//#endregion

	//#region Computed

	public viewMode = computed<DashboardViewMode>(() => {
		const authState = this.authorizationStateService.authorizationState();
		if (!authState) return DashboardViewMode.Loading;

		if (this.authorizationService.isStaff(authState)) {
			return DashboardViewMode.Staff;
		}

		if (this.userSessionService.hasNoActiveOrganizations()) {
			return DashboardViewMode.NoActiveOrganizations;
		}

		return DashboardViewMode.OrgMember;
	});

	public greeting = computed<string>(() => {
		const user = this.userSessionService.activeUser();
		if (!user) return 'Welcome';
		return `Welcome, ${user.firstName}`;
	});

	//#endregion
}
